import { useMemo } from 'react';
import { ResolveResponse } from '@trello/smart-card/object-resolver-client';

import { SmartLinkAnalyticsContextType } from './types';

export const useSmartLinkAnalytics = (
  resolvedUrl: ResolveResponse | undefined,
  additionalContext: SmartLinkAnalyticsContextType,
) => {
  const { source, attributes, containers } = additionalContext;

  return useMemo(
    () => ({
      source,
      attributes: {
        definitionId: resolvedUrl?.meta?.definitionId,
        accessType: resolvedUrl?.meta?.requestAccess?.accessType,
        cloudId: resolvedUrl?.meta?.requestAccess?.cloudId,
        urlType: resolvedUrl?.data?.generator?.name,
        urlAccess: resolvedUrl?.meta?.access,
        ...(attributes && attributes),
        containers,
      },
    }),
    // For some reason, enumerating the exact dependencies makes the test "useSmartLinkAnalytics hook › returns same value when param remains the same instance" fail
    // eslint-disable-next-line @trello/exhaustive-deps
    [resolvedUrl, attributes, source, containers],
  );
};
